import { render, staticRenderFns } from "./AccettazioneSsnEditViewComponent.vue?vue&type=template&id=2ef96f5f&scoped=true"
import script from "./AccettazioneSsnEditViewComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnEditViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnEditViewComponent.vue?vue&type=style&index=0&id=2ef96f5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef96f5f",
  null
  
)

export default component.exports